module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [_c('submenu'), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_Name",
      "validate": _vm.$v.model,
      "modelPath": "name",
      "acc": "name"
    },
    on: {
      "input": _vm.$v.model.$touch
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", $$v)
      },
      expression: "model.name"
    }
  }), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_Amount",
      "validate": _vm.$v.model,
      "modelPath": "amount",
      "type": "number",
      "min": 0,
      "max": 5000,
      "step": "0.01",
      "acc": "amount"
    },
    on: {
      "input": _vm.$v.model.$touch
    },
    model: {
      value: (_vm.model.amount),
      callback: function($$v) {
        _vm.$set(_vm.model, "amount", $$v)
      },
      expression: "model.amount"
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loading,
      "label": "Label_SaveButton"
    },
    on: {
      "click": _vm.save
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Label_CancelButton",
      "withBorder": true
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'taxes'
        })
      }
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51329142!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/membership/taxes/Tax.vue
// module id = 734
// module chunks = 1